/*
 * @Author: cn1994
 * @Date: 2023-12-28 17:16:51
 * @LastEditors: cn1994
 * @LastEditTime: 2024-05-30 11:21:00
 * @Description: file content
 */
import { useBaseStore } from "@/stores/base";
import dayjs from 'dayjs'
import { useUserStore } from '@/stores/user'
import { useInstStore } from "@/stores/inst";


const volcengineMixin = {
  data() {
    let baseStore = useBaseStore()
    const userStore = useUserStore()
    const instStore = useInstStore()
    return {
      baseStore,
      userStore,
      instStore
    }
  },
  methods: {
    // 菜单点击埋点
    menuClick(title) {
      this.setHuoShanConfigUserUniqueId()
      window.collectEvent('bm_menu', {
        bm_admin_role: this.userStore.adminRole,
        bm_role: this.userStore.role,
        bm_inst_code: this.userStore.instCode,
        bm_inst_id: this.userStore.instId,
        bm_subject: this.instStore.subject,
        bm_click_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        bm_user_name: this.userStore.userName,
        bm_user_id: this.userStore.userId,
        bm_menu_title: title
      });
    },
    // 内容点击埋点
    contentClick(params) {
      this.setHuoShanConfigUserUniqueId()
      window.collectEvent('bm_click', {
        bm_admin_role: this.userStore.adminRole,
        bm_role: this.userStore.role,
        bm_inst_code: this.userStore.instCode,
        bm_inst_id: this.userStore.instId,
        bm_subject: this.instStore.subject,
        bm_click_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        bm_user_name: this.userStore.userName,
        bm_user_id: this.userStore.userId,
        ...params
      });
    },
    // 筛选埋点
    // bmFilter(params) {
    //   this.setHuoShanConfigUserUniqueId()
    //   window.collectEvent('bm_filter', {
    //     bm_admin_role: this.userStore.adminRole,
    //     bm_role: this.userStore.role,
    //     bm_inst_code: this.userStore.instCode,
    //     bm_inst_id: this.userStore.instId,
    //     bm_subject: this.instStore.subject,
    //     bm_filter_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    //     bm_user_name: this.userStore.userName,
    //     bm_user_id: this.userStore.userId,
    //     ...params
    //   });
    // },
    setHuoShanConfigUserUniqueId() {
      // 设置config
      const uniqueUserId = `${this.userStore.serverId}_${this.userStore.userId}`
      window.collectEvent('config', {user_unique_id: uniqueUserId});
    }
  }
}

export default volcengineMixin